module.exports = __webpack_public_path__ + "static/media/tulip-red.32f0a877.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tulip-red.jpeg
// module id = 525
// module chunks = 0